import { Article } from './article'

/**
 * Model representing a contract.
 */
export class Contract {

  public id: string;
  public createdAt: any;

  public templateTitle: string;
  public templateDescription: string;
  public name: string;

  public description: string;
  public sides: any;
  public headline: string;
  public title: string;
  public articles: Article[];
  public datePlace: any;
  public signatures: any[];

  public noArticleTitle: boolean;
  public noArticleNumbers: boolean;

  constructor(jsonStr: string) {
    let jsonObj: any = JSON.parse(jsonStr);
    for (let prop in jsonObj) {
      this[prop] = jsonObj[prop];
    }
  }

}



// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/model/contract.ts